import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { SlideModel } from "src/core/categories/categories.models";
import { CategoriesSandbox } from "src/core/categories/categories.sandbox";
import { MessageService } from "src/core/services/messages.service";

@Component({
    templateUrl: './slider-selection.dialog.html',
    styleUrls: ['./slider-selection.dialog.scss']
})
export class SliderSelectionDialogComponent implements OnInit, OnDestroy {
    private subs: Subscription[] = [];

    sliders: SlideModel[] = [];

    constructor(
        public categoriesSandbox: CategoriesSandbox,
        private message: MessageService,
        private dialogRef: MatDialogRef<SliderSelectionDialogComponent>
    ) {
        this.categoriesSandbox.doClearGetSlidersState();
    }

    ngOnInit(): void {
        this.categoriesSandbox.doGetSliders({});

        this.subs.push(this.categoriesSandbox.getSlidersData$.subscribe(res => {
            if (res) {
                this.sliders = res || [];
            }
        }))
        this.subs.push(this.categoriesSandbox.getSlidersFailData$.subscribe(res => {
            if (res) {
                this.message.log('Server error!');
            }
        }))
    }

    selectItem(item: SlideModel): void {
        if (item && item.id) {
            this.dialogRef.close(item);
        }
    }

    ngOnDestroy(): void {
        this.subs.map(s => s.unsubscribe())
    }
}